import { FileText, Upload } from "lucide-react"
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
  ResponsiveDialogDescription,
  ResponsiveDialogFooter,
  ResponsiveDialogClose,
} from "@/components/ui/responsive-dialog"
import { Button } from "@/components/ui/button"

export function NewArticleChooserDialog({ open, onOpenChange, onStartScratch, onUploadTranscript }) {
  const cards = [
    {
      icon: FileText,
      title: "Start from Scratch",
      description: "Create a blank article and write it yourself.",
      action: onStartScratch,
    },
    {
      icon: Upload,
      title: "Upload Transcript",
      description: "Upload a meeting transcript and let AI generate an article draft.",
      action: onUploadTranscript,
    },
  ]

  return (
    <ResponsiveDialog open={open} onOpenChange={onOpenChange}>
      <ResponsiveDialogContent className="sm:max-w-md">
        <ResponsiveDialogHeader>
          <ResponsiveDialogTitle className="font-display text-xl">
            New Article
          </ResponsiveDialogTitle>
          <ResponsiveDialogDescription>
            How would you like to create your article?
          </ResponsiveDialogDescription>
        </ResponsiveDialogHeader>

        <div className="grid gap-3 py-4 px-4 sm:px-0">
          {cards.map((card) => (
            <button
              key={card.title}
              onClick={card.action}
              className="flex items-start gap-4 p-4 rounded-lg border border-zinc-200 text-left hover:border-kf-red hover:bg-red-50/50 transition-colors group"
            >
              <div className="w-10 h-10 rounded-full bg-zinc-100 group-hover:bg-kf-red/10 flex items-center justify-center flex-shrink-0">
                <card.icon className="w-5 h-5 text-zinc-600 group-hover:text-kf-red" />
              </div>
              <div>
                <p className="font-semibold text-zinc-900 group-hover:text-kf-red">{card.title}</p>
                <p className="text-sm text-zinc-500 mt-0.5">{card.description}</p>
              </div>
            </button>
          ))}
        </div>

        <ResponsiveDialogFooter>
          <ResponsiveDialogClose asChild>
            <Button type="button" variant="outline">
              Cancel
            </Button>
          </ResponsiveDialogClose>
        </ResponsiveDialogFooter>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  )
}
